import { Component, OnInit, ViewEncapsulation, HostListener } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DatePipe } from '@angular/common';
import { AccountServiceProvider } from '../../providers/account-service/account-service';
import { Shareddata } from '../../providers/shareddata';
import { FuncsService } from '../../services/funcs.services';
import smoothscroll from 'smoothscroll-polyfill';
import { NgxSelectModule } from 'ngx-select-ex';
import { NgbDropdownConfig } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector      : 'app-programme',
	templateUrl   : './programme.component.html',
	encapsulation : ViewEncapsulation.None,
	providers     : [DatePipe, NgbDropdownConfig]
})

export class ProgrammeComponent implements OnInit {
	public offset_params       : number;
	public data_limit          : number;
	public searchCount         : number = 0;
	public detail_tag          : number = 0;
	public detail_session      : number = 0;
	public detail_weekday      : number = 0;
	public detail_goldstandard : number = 0;
	public detail_opensession  : number = 0;
	public detail_filter_count : number = 0;
	public filterCount         : number;
	public week_day_name          : any;
	public week_day_id            : any = 0;
	public current_season         : any;
	public selectedYear           : any;
	public content_type           : any;
	public view_type              : any;
	public schedule_params        : any;
	public show_tags              : any;
	public back_to_url            : any;
	public source                 : any = 'list';
	public error_message          : any;
	public scheduleSearchOption   : any = 'All';
	public searchText             : any;
	public dateTime               : any;
	public activeDate             : any;
	public activeTime             : any;
	public firstDate              : any;
	public currentDay             : any;
	public filter_schedule_params : any;
	public lastInterval           : any;
	public tag_list_name      : any = [];
	public tag_list_id        : any = [];
	public breadCrumbData     : any = [];
	public schedule_data      : any = [];
	public scheduleDotNetData : any = [];
	public scheduleTags       : any = [];
	public scheduleSessions   : any = [];
	public scheduleYear       : any = [];
	public all_data           : any = [];
	public dateTimeArray      : any = [];
	public curDays            : any = [];
	public newDaysArr         : any = [];
	public focus_area         : any = '';
	public is_conference          : boolean = false;
	public showSelectedTagsText   : boolean = false;
	public showSelectedtags       : boolean = false;
	public showSelectedgold       : boolean = false;
	public showOpensession        : boolean = false;
	public showSelecteddays       : boolean = false;
	public showSelectedsession    : boolean = false;
	public showSearchDiv          : boolean = false;
	public tagsAll                : boolean = true;
	public daysAll                : boolean = true;
	public sessionAll             : boolean = true;
	public defaultButton          : boolean = false;
	public loadMoreButton         : boolean = false;
	public showMoreButton         : boolean = false;
	public filterButton           : boolean = false;
	public error_message_show     : boolean = false;
	public show_all_events_button : boolean = false;
	public isLastDate             : boolean = false;
	public programTagsGet         : boolean = false;
	public programYearGet         : boolean = false;
	public isMobile               : boolean;
	public showTimezone           : boolean = false;
	public timeZones        : Array<NgxSelectModule>;
	public selectedTimezone : any = 'W. Europe Standard Time';

	constructor(
		private router         : Router,
		private route          : ActivatedRoute,
		private datePipe       : DatePipe,
		private accountService : AccountServiceProvider,
		public shareddata      : Shareddata,
		private funcs          : FuncsService,
    config: NgbDropdownConfig
	) {
		smoothscroll.polyfill();
    	config.autoClose = 'outside';
		this.isMobile = this.funcs.globalDetectDevice();
		/* routing */
		this.router.routeReuseStrategy.shouldReuseRoute = function () {
			return false;
		};
		/* routing */
		var userData = this.funcs.globalSetUserSession();
		if ( userData )
			this.shareddata.setUserSession( userData );
		// this.loadScripts();
		let api;
		let params;
		let year_id;
		let current_url;
		let load_type = 'old';
		current_url = this.router.url;
		if ( current_url.includes( '?' ) )
			current_url = current_url.split('?')[0];

		sessionStorage.setItem( 'currentPageUrl', JSON.stringify({ prev_url: current_url }) );

		if ( this.route.snapshot.paramMap.get('slug') != null ) {
			var year = this.route.snapshot.paramMap.get('slug');
			year_id = year.split('-')[0];
			var numbers = new RegExp(/^[0-9]+$/);
			if ( numbers.test( year_id ) ) {
				var last_param = current_url.substring( current_url.lastIndexOf( '/' ) + 1 );
				current_url = current_url.replace( new RegExp( last_param ), '' );
			} else
				this.funcs.globalNavigate( '/404' );
		} else {
			year_id = 0;
			this.route.queryParams.subscribe(params => {
				if ( params[ 'tg' ] ) {
					load_type = 'new';
					this.defaultButton = false;
					this.showMoreButton = false;
					this.detail_tag = params['tg'];
					this.source = 'detail';
					this.detail_filter_count = 1;
					this.filterButton = true;
					this.showSelectedTagsText = true;
					this.showSelectedtags = true;
					this.tagsAll = false;
					if ( 'clickedName' in window.sessionStorage )
						this.tag_list_name.push( JSON.parse( sessionStorage.getItem( 'clickedName' ) ) );
					else {
						let tag_params = {
							'tag_id': params['tg'],
						}
						this.accountService.getTagName( tag_params ).then( ( dotnetresponse: any ) => {
							if ( 'Ok' == dotnetresponse.status )
								this.tag_list_name.push( dotnetresponse.tagName );
						});
					}
					this.tag_list_id.push( params['tg'] );
				} else if ( params['dn'] ) {
					load_type = 'new';
					this.defaultButton = false;
					this.showMoreButton = false;
					this.detail_weekday = params['dn'];
					this.source = 'detail';
					this.detail_filter_count = 1;
					this.filterButton = true;
					if ( 'clickedName' in window.sessionStorage )
						this.week_day_name = JSON.parse( sessionStorage.getItem('clickedName') );
					else {
						if ( 1 == params['dn'] )
							this.week_day_name = 'SUNDAY';
						else if ( 2 == params['dn'] )
							this.week_day_name = 'MONDAY';
						else if ( 3 == params['dn'] )
							this.week_day_name = 'TUESDAY';
						else if ( 4 == params['dn'] )
							this.week_day_name = 'WEDNESDAY';
						else if ( 5 == params['dn'] )
							this.week_day_name = 'THURSDAY';
						else if ( 6 == params['dn'] )
							this.week_day_name = 'FRIDAY';
					}
					this.week_day_id = params['dn'];
				} else if ( params['et'] ) {
					load_type = 'new';
					this.defaultButton = false;
					this.showMoreButton = false;
					this.detail_session = params['et'];
					this.source = 'detail';
					this.detail_filter_count = 1;
					this.filterButton = true;
					this.showSelectedsession = true;
					this.sessionAll = false;
				} else if ( params['gs'] ) {
					load_type = 'new';
					this.defaultButton = false;
					this.showMoreButton = false;
					if ( 'true' == params['gs'] || 'True' == params['gs'] ) {
						this.detail_goldstandard = 1;
						this.source = 'detail';
						this.filterButton = true;
						this.showSelectedTagsText = true;
						this.showSelectedgold = true;
						this.tag_list_name.push( 'goldstandard' );
						this.tag_list_id.push( 5000 );
					}
				} else if ( params['os'] ) {
					load_type = 'new';
					this.defaultButton = false;
					this.showMoreButton = false;
					if ( 'true' == params['os'] || 'True' == params['os'] ) {
						this.detail_opensession = 1;
						this.source = 'detail';
						this.filterButton = true;
						this.showSelectedTagsText = true;
						this.showOpensession = true;
						this.tag_list_name.push( 'opensession' );
						this.tag_list_id.push( 25000 );
					}
				} else {
					load_type = 'old';
					this.detail_goldstandard = 0;
					this.detail_opensession = 0;
				}
			});
		}

		params = {
			'slug': current_url,
		};

		if ( 'filterProgrammeKeys' in window.sessionStorage ) {
			let localSessionItems = JSON.parse( sessionStorage.getItem( 'filterProgrammeKeys' ) );
			if ( this.isMobile && 'event' == localSessionItems.type ) {
				sessionStorage.removeItem( 'filterProgrammeKeys' );
				sessionStorage.removeItem( 'filterProgrammeTags' );
				sessionStorage.removeItem( 'filterProgrammeSessions' );
				sessionStorage.removeItem( 'filterProgrammeYear' );
				this.defaultLoad( params, year_id );
			} else {
				if ( 'filterClick' in window.localStorage && 'exhibition' != localSessionItems.type && 'old' == load_type ) {
					if ( localSessionItems.current_url != this.router.url )
						this.defaultLoad( params, year_id );
					else {
						this.content_type = localSessionItems.type;
						localSessionItems.type = localSessionItems.type
						sessionStorage.setItem( 'filterProgrammeKeys', JSON.stringify( localSessionItems ) );
						if ( 0 != localSessionItems.tag_id ) {
							this.filterButton = true;
							this.showSelectedTagsText = true;
							this.showSelectedtags = true;
							this.tagsAll = false;
							if ( localSessionItems.tag_count > 1 ) {
								var tag_array = localSessionItems.filter_id.split( ',' );
								tag_array.forEach((item, index) => {
									this.tag_list_id.push(item);
								});
								var tag_array = localSessionItems.tag_names.split( ',' );
								tag_array.forEach((item, index) => {
									this.tag_list_name.push(item);
								});
							} else {
								this.tag_list_name.push(localSessionItems.tag_names);
								this.tag_list_id.push(localSessionItems.tag_id);
							}
						}
						if ( 0 != localSessionItems.goldstandard ) {
							this.filterButton = true;
							this.showSelectedTagsText = true;
							this.showSelectedgold = true;
							this.tag_list_name.push('goldstandard');
							this.tag_list_id.push(5000);
						}
						if (0 != localSessionItems.opensession) {
							this.filterButton = true;
							this.showSelectedTagsText = true;
							this.showOpensession = true;
							this.tag_list_name.push('opensession');
							this.tag_list_id.push(25000);
						}
						if (0 != localSessionItems.weekday_id) {
							this.filterButton = true;
							this.week_day_id = localSessionItems.weekday_id;
							this.week_day_name = localSessionItems.weekday_name;
						}
						if (0 != localSessionItems.session_id) {
							this.filterButton = true;
							this.showSelectedsession = true;
							this.sessionAll = false;
						}

						params = {
							'slug': current_url,
							'offset': 0,
							'type': localSessionItems.type,
							'year': year_id,
							'search_text': localSessionItems.search_text,
							'search_option': localSessionItems.search_option,
						};
						this.scheduleSearchOption = localSessionItems.search_option;
						this.searchText = localSessionItems.search_text;
						let wp_params = {
							'slug': current_url,
						}
						localSessionItems.offset = 0;
						this.accountService.getProgrammePageData(wp_params).then((response: any) => {
							if ('Ok' === response.status) {
								if ( response.seo_data ) {
				                    var alternateTitle = response.content_type[0].toUpperCase() + response.content_type.slice( 1 ) + ' | ' + response.current_season[0].toUpperCase() + response.current_season.slice( 1 );
				                    this.funcs.globalSeoData( response, alternateTitle );
				                }
								this.content_type = response.content_type;
								this.show_tags = response.show_tags;
								this.breadCrumbData = response.breadcrumb;
								this.current_season = response.current_season;
							}
							if ('conference' == this.current_season) {
								this.show_all_events_button = true;
								this.is_conference = true;
								localSessionItems.season = true;
							}
							sessionStorage.setItem('filterProgrammeKeys', JSON.stringify(localSessionItems));
						});
						let localSessionSeason = JSON.parse(sessionStorage.getItem('currentSeason'));
						if (true == localSessionSeason.conference) {
							this.currentDay = 'All days';
							sessionStorage.removeItem('filterProgrammeKeys');
							sessionStorage.removeItem('filterProgrammeTags');
							sessionStorage.removeItem('filterProgrammeSessions');
							sessionStorage.removeItem('filterProgrammeYear');
							this.defaultLoad(params, year_id);
						} else
							this.getFilterData(params, localSessionItems);
					}
				} else {
					sessionStorage.removeItem('filterProgrammeKeys');
					sessionStorage.removeItem('filterProgrammeTags');
					sessionStorage.removeItem('filterProgrammeSessions');
					sessionStorage.removeItem('filterProgrammeYear');
					this.defaultLoad(params, year_id);
				}
			}
		} else
			this.defaultLoad(params, year_id);

		this.accountService.getBreadCrumb(params).then((response: any) => {
			if ('Ok' === response.status)
				this.breadCrumbData = response.breadcrumb;
			// if (true != this.shareddata.checkLoaded())
			// 	this.shareddata.setDataLoaded(true);
		});
		this.accountService.getTimeZone().then((result: any) => {
			if ('Ok' == result.status) {
				let arrTimeZone = [];
				// arrTimeZone.push({ id: 0, text: 'Select timezone' });
				result.timezone.forEach(element => {
					const certif = { id: element.id, text: element.timeZone };
					arrTimeZone.push(certif);
				});
				this.timeZones = arrTimeZone;
			}
		});
		sessionStorage.setItem('currentPageID', JSON.stringify(0));
	}

	@HostListener('window:popstate', ['$event'])
	onPopState(event) {
		location.reload();
	}

	loadScripts() {
		const dynamicScripts = [
			'assets/js/custom.js'
		];
		for (let i = 0; i < dynamicScripts.length; i++) {
			const node = document.createElement('script');
			node.src = dynamicScripts[i];
			node.type = 'text/javascript';
			node.async = false;
			document.getElementsByTagName('head')[0].appendChild(node);
		}
	}

	getYearTime(params = null) {
		this.programTagsGet = false;
		this.programYearGet = false;
		var date = new Date();
		Promise.all([this.accountService.getProgrammeDateTime()]).then((dotnetresponse: any) => {
			if ('Ok' == dotnetresponse[0].status) {
				this.dateTime = dotnetresponse[0].dateList;
				this.activeDate = this.dateTime[0].eventDate;
				this.firstDate = this.activeDate;
				this.activeTime = this.dateTime[0].timeInterval[0];
				var groupByDateTime = {};
				this.dateTime.forEach(function (a, b) {
					var timeArray = [];
					a.timeInterval.forEach(function (a, b) {
						timeArray.push(a);
					});

					groupByDateTime[a.eventDate] = groupByDateTime[a.eventDate] || [];
					groupByDateTime[a.eventDate].push({ time: timeArray });
					groupByDateTime[a.eventDate].push({ remarks: a.remarks });
					groupByDateTime[a.eventDate].push({ eventdate: a.date });
				});

				var myArray1 = Object.keys(groupByDateTime).map(function (key) {
					return { date: key, values: groupByDateTime[key] };
				});
				this.dateTimeArray = myArray1;
				var conference = '';
				if (undefined != params.is_conference)
					conference = params.is_conference;

				this.schedule_params = {
					'date': this.activeDate,
					'is_conference': conference,
				}
				this.accountService.getProgrammesByDateTime(this.schedule_params).then((dotnetresponse: any) => {
					if (dotnetresponse.status == 'Ok') {
						this.schedule_data = dotnetresponse.programmes;
						var currentDateTimeArr = this.schedule_data[0].dateInterval.split('|');
						if ('' != conference && conference) {
							this.activeDate = this.datePipe.transform(date, "yyyy-MM-dd") + 'T00:00:00';
							this.activeTime = currentDateTimeArr[1];
						}
						let objIndex = this.dateTimeArray.findIndex((obj => obj.date == this.activeDate));
						let dateTimeCount = this.dateTimeArray.length;
						if (objIndex == dateTimeCount - 1)
							this.isLastDate = true;
						else
							this.isLastDate = false;

						this.all_data = this.schedule_data;
						var groupByInterval = {};
						let c = this.schedule_data;
						this.schedule_data.forEach(function (a, b, c) {
							a.class = '';
							if (b > 0) {
								if (a.dateInterval != c[b - 1].dateInterval)
									a.class = 'blue-separator';
							} else if (b == 0) {
								if (a.dateInterval == c[b].dateInterval)
									a.class = 'blue-separator';
							}

							var leftConvenor = [];
							var rightConvenor = [];
							if (a.convenors.length > 0) {
								var convenor_count = a.convenors.length;
								var convenor_half_count = Math.round(convenor_count / 2);

								if (1 == convenor_count)
									leftConvenor = a.convenors;
								if (1 < convenor_count) {
									a.convenors.forEach(function (a, b) {
										if (b < convenor_half_count)
											leftConvenor.push(a);
										else
											rightConvenor.push(a);
									});
								}
							}
							if ( null != a.otherConvenor ) {
								if ( leftConvenor.length > rightConvenor.length ) {
									rightConvenor.push( {'name':a.otherConvenor} );
								} else {
									leftConvenor.push( {'name':a.otherConvenor} );
								}
							}

							groupByInterval[a.dateInterval] = groupByInterval[a.dateInterval] || [];
							groupByInterval[a.dateInterval].push({ val: a, lConvenor: leftConvenor, rConvenor: rightConvenor });
						});

						var object_length = Object.keys(groupByInterval).length;
						var increment = 0;
						var lstintval;
						var myArray2 = Object.keys(groupByInterval).map(function (key) {
							if (increment == object_length - 1)
								lstintval = key;
							var interval_arr = key.split('|');
							var day = interval_arr[0];
							var time = interval_arr[1];
							var seperator_class = groupByInterval[key][0].val.class;
							increment++;
							return { interval: key, values: groupByInterval[key], day: day, time: time, eventSeparatorClass: groupByInterval[key][0].val.class, eventdate:  groupByInterval[key][0].val.eventDate };
						});
						myArray2.forEach(( items, indexs ) => {
							this.dateTimeArray.forEach((item, index) => {
								if( item.values[2].eventdate == items.eventdate ) {
									myArray2[indexs]['focus_area'] = item.values[1].remarks ;
								}
							});
						});
						this.scheduleDotNetData = myArray2;
						this.lastInterval = lstintval;
						this.offset_params = params.offset;
						this.data_limit = dotnetresponse.limit;
						/* add to sessionStorage */
						let myObj = {
							offset: this.offset_params,
							type: 'event',
							favourites: 0,
							limit: dotnetresponse.limit, /* data limit */
							current_url: this.router.url,
							year: params.year,
							season: params.is_conference,
							search_text: params.search_text,
							search_option: params.search_option,
							filter_type_count: 0,
							weekday_id: 0,
							session_id: 0,
							goldstandard: 0,
							opensession: 0,
							tag_count: 0,
							view: 'list',
							filter_id: 0,
							date: this.activeDate,
							next_offset: 10,
							timezone: this.selectedTimezone,
						};

						sessionStorage.setItem('filterProgrammeKeys', JSON.stringify(myObj));
						let localSessionItems = JSON.parse(sessionStorage.getItem('filterProgrammeKeys'));
						this.back_to_url = localSessionItems.current_url;
						if ('exhibition' != this.schedule_params.type) {
							var elems = document.querySelectorAll('.schedule__view--activated');

							if (elems.length > 0) {
								elems[0].classList.remove('schedule__view--activated');
								document.getElementById(localSessionItems.view).classList.add('schedule__view--activated');
							}
						}
						if (document.getElementById('schedule__events').classList.contains('schedule__events-extended-view'))
							document.getElementById('schedule__events').classList.remove('schedule__events-extended-view');
						if (document.getElementById('schedule__events').classList.contains('schedule__events-reduced-view'))
							document.getElementById('schedule__events').classList.remove('schedule__events-reduced-view');
						if ('extended' == localSessionItems.view || 'list' == localSessionItems.view)
							document.getElementById('schedule__events').classList.add('schedule__events-extended-view');
						else
							document.getElementById('schedule__events').classList.add('schedule__events-reduced-view');

						params.date = this.activeDate;
					}
					this.showTimezone = true;
					this.defaultButton = false;
					this.filterButton = false;

					let count = this.schedule_data.length;
					if (count >= dotnetresponse.limit) {
						this.showMoreButton = true;
						this.filterCount = 1;
					} else {
						this.showMoreButton = false;
						this.filterCount = 0;
					}

					setTimeout(() => {
						this.ngAfterViewInit();
					}, 3000);
				});
			}
		});
	}

	defaultLoad(params, year_id) {
		this.defaultButton = true;
		this.accountService.getProgrammePageData(params).then((result: any) => {
			if ('Ok' === result.status) {
				if ( result.seo_data ) {
                    var alternateTitle = result.content_type[0].toUpperCase() + result.content_type.slice( 1 ) + ' | ' + result.current_season[0].toUpperCase() + result.current_season.slice( 1 );
                    this.funcs.globalSeoData( result, alternateTitle );
                }
				this.content_type = result.content_type;
				this.show_tags = result.show_tags;
				this.current_season = result.current_season;
				if ( 0 == year_id ) {
					if ('conference' == this.current_season) {
						this.show_all_events_button = true;
						this.is_conference = true;
						var d = new Date();
						var weekday = new Array(7);
						weekday[0] = "Sunday";
						weekday[1] = "Monday";
						weekday[2] = "Tuesday";
						weekday[3] = "Wednesday";
						weekday[4] = "Thursday";
						weekday[5] = "Friday";
						weekday[6] = "Saturday";
						this.currentDay = weekday[d.getDay()];
						this.daysAll = false;
						this.week_day_id = d.getDay() + 1;
					}
					sessionStorage.setItem('currentSeason', JSON.stringify({ conference: this.is_conference }));
				} else {
					this.is_conference = false;
				}

				if ('exhibition' == this.content_type)
					this.view_type = 'thumbnail';
				else
					this.view_type = 'list';

				this.schedule_params = {
					'offset': 0,
					'type': this.content_type,
					'year': year_id,
					'is_conference': this.is_conference,
					'tag_id': this.detail_tag,
					'weekday_id': this.detail_weekday,
					'session_id': this.detail_session,
					'goldstandard': this.detail_goldstandard,
					'opensession': this.detail_opensession,
					'search_text': '',
					'search_option': '',
					'timezone': this.selectedTimezone,
				}

				if (this.isMobile && 'event' == this.content_type)
					this.getYearTime(this.schedule_params);
				else {
					this.accountService.getCurrentDays(this.schedule_params).then((dotnetresponse: any) => {
						if ('Ok' === dotnetresponse.status) {
							// var daysArray = [];
							// dotnetresponse.DayList.forEach(function (a, b) {
							// 	daysArray.push(a.dayName);
							// });
							// this.curDays = daysArray;
							var daysArray = [];
							dotnetresponse.DayList.forEach( function( a, b ) {
								daysArray.push(a);
							});
							this.newDaysArr = daysArray;
							this.curDays = daysArray;
						}
					});
					this.accountService.getProgrammes(this.schedule_params).then((dotnetresponse: any) => {
						if (dotnetresponse.status == 'Ok') {
							this.schedule_data = dotnetresponse.programmes;
							var lastinteval;
							var groupByInterval = {};

							let c = this.schedule_data;

							this.schedule_data.forEach(function (a, b, c) {
								a.class = '';
								if (b > 0) {
									if (a.dateInterval != c[b - 1].dateInterval)
										a.class = 'blue-separator';
								} else if (b == 0) {
									if (a.dateInterval == c[b].dateInterval)
										a.class = 'blue-separator';
								}

								var leftConvenor = [];
								var rightConvenor = [];
								if (a.convenors.length > 0) {
									var convenor_count = a.convenors.length;
									var convenor_half_count = Math.round(convenor_count / 2);

									if (1 == convenor_count)
										leftConvenor = a.convenors;
									if (1 < convenor_count) {
										a.convenors.forEach(function (a, b) {
											if (b < convenor_half_count)
												leftConvenor.push(a);
											else
												rightConvenor.push(a);
										});
									}
								}

								if ( null != a.otherConvenor ) {
									if ( leftConvenor.length > rightConvenor.length ) {
										rightConvenor.push( {'name':a.otherConvenor} );
									} else {
										leftConvenor.push( {'name':a.otherConvenor} );
									}
								}

								groupByInterval[a.dateInterval] = groupByInterval[a.dateInterval] || [];
								groupByInterval[a.dateInterval].push({ val: a, lConvenor: leftConvenor, rConvenor: rightConvenor });
							});

							if ('exhibition' == this.schedule_params.type) {
								var myArray = Object.keys(groupByInterval).map(function (key) {
									var day = 'Exhibitors';
									var time = 'All Week';

									return { interval: key, values: groupByInterval[key], day: day, time: time, eventSeparatorClass: '', eventdate:  groupByInterval[key][0].val.eventDate };
								});
								this.scheduleDotNetData = myArray;
							} else {
								var object_length = Object.keys(groupByInterval).length;
								var increment = 0;
								var lstintval;
								var myArray1 = Object.keys(groupByInterval).map(function (key) {
									if (increment == object_length - 1)
										lstintval = key;
									var interval_arr = key.split('|');
									var day = interval_arr[0];
									var time = interval_arr[1];
									var seperator_class = groupByInterval[key][0].val.class;
									increment++;
									return { interval: key, values: groupByInterval[key], day: day, time: time, eventSeparatorClass: groupByInterval[key][0].val.class, eventdate:  groupByInterval[key][0].val.eventDate };
								});
								myArray1.forEach(( items, indexs ) => {
									this.curDays.forEach((item, index) => {
										if ( items.eventdate == item.date ) {
											myArray1[indexs]['focus_area'] = item.remarks;
										}
									});
								});
								this.scheduleDotNetData = myArray1;
								this.lastInterval = lstintval;
							}

							if (this.scheduleDotNetData) {
								if (this.scheduleDotNetData.length > 0) {
									if (this.scheduleDotNetData[0].values.length > 0) {
										let intro_content = this.scheduleDotNetData[0].values[0].val.introduction.toString();
										intro_content = intro_content.replace(/(<([^>]+)>)/ig, '');
									}
								}
							}

							this.offset_params = this.schedule_params.offset;
							this.data_limit = dotnetresponse.limit;

							/* add to sessionStorage */
							let myObj = {
								offset: this.offset_params,
								type: this.content_type,
								view: this.view_type,
								favourites: 0,
								filter_type_count: this.detail_filter_count, /* count how many filter clicked(tags, weekdays, goldstandard ) */
								tag_id: this.detail_tag, /* tag id of current clicked tag */
								session_id: this.detail_session, /* id of session clicked */
								weekday_id: this.detail_weekday, /* id of weekday clicked */
								weekday_name: this.week_day_name,
								filter_id: this.detail_tag == 0 ? 0 : [this.detail_tag], /* add tag id as array for multiple */
								tag_count: this.detail_tag == 0 ? 0 : 1, /* count how many tags clicked(tags only) */
								limit: dotnetresponse.limit, /* data limit */
								goldstandard: this.detail_goldstandard == 1 ? 1 : 0, /* for goldstandard */
								opensession: this.detail_opensession == 1 ? 1 : 0,  /* for opensession */
								tag_names: this.tag_list_name, /* tag names as array */
								current_url: this.router.url,
								year: this.schedule_params.year,
								season: this.schedule_params.is_conference,
								search_text: this.schedule_params.search_text,
								search_option: this.schedule_params.search_option,
								next_offset: 10,
								timezone: this.selectedTimezone,
							};

							sessionStorage.setItem('filterProgrammeKeys', JSON.stringify(myObj));

							let localSessionItems = JSON.parse(sessionStorage.getItem('filterProgrammeKeys'));
							this.back_to_url = localSessionItems.current_url;

							if ('exhibition' != this.schedule_params.type) {
								var elems = document.querySelectorAll('.schedule__view--activated');

								if (elems.length > 0) {
									elems[0].classList.remove('schedule__view--activated');
									document.getElementById(localSessionItems.view).classList.add('schedule__view--activated');
								}
							}
							if (document.getElementById('schedule__events').classList.contains('schedule__events-extended-view'))
								document.getElementById('schedule__events').classList.remove('schedule__events-extended-view');
							if (document.getElementById('schedule__events').classList.contains('schedule__events-reduced-view'))
								document.getElementById('schedule__events').classList.remove('schedule__events-reduced-view');
							if ('extended' == localSessionItems.view || 'list' == localSessionItems.view)
								document.getElementById('schedule__events').classList.add('schedule__events-extended-view');
							else
								document.getElementById('schedule__events').classList.add('schedule__events-reduced-view');

							let count = this.schedule_data.length;

							if (count >= dotnetresponse.limit)
								this.showMoreButton = true;
							else
								this.showMoreButton = false;
						}
						this.defaultButton = false;
						this.filterButton = false;
						this.filterCount = 1;
						this.showTimezone = true;

						setTimeout(() => {
							this.ngAfterViewInit();
						}, 3000);
					});
				}
			} else {
				this.error_message_show = true;
				if ( '3111' == result.errCode ) {
					this.error_message = 'Oops, looks like something went wrong!';
				} else {
					this.error_message = result.message;
				}
			}
		});
	}

	getProgramTags() {
		if (this.programTagsGet == false) {
			// $( '#tagloading1' ).removeClass( 'hide' );
			document.querySelector('#tagloading1').classList.remove('hide');
			let curparams;
			if (typeof this.schedule_params == 'undefined')
				curparams = this.filter_schedule_params;
			else
				curparams = this.schedule_params;
			this.accountService.getTagsSessions(curparams).then((dotnetresponse: any) => {
				if ('Ok' === dotnetresponse.status) {
					// $( '#tagloading1' ).addClass( 'hide' );
					document.querySelector('#tagloading1').classList.add('hide');
					this.programTagsGet = true;
					this.scheduleTags = dotnetresponse.tags;
					this.scheduleSessions = dotnetresponse.sessions;
					sessionStorage.setItem('filterProgrammeTags', JSON.stringify({ prog_tags: this.scheduleTags }));
					sessionStorage.setItem('filterProgrammeSessions', JSON.stringify({ prog_sessions: this.scheduleSessions }));
				}
			});
		}
	}

	getProgramYear() {
		if (this.programYearGet == false) {
			let curparams;
			if (typeof this.schedule_params == 'undefined')
				curparams = this.filter_schedule_params;
			else
				curparams = this.schedule_params;
			this.accountService.getYears(curparams).then((dotnetresponse: any) => {
				if ('Ok' === dotnetresponse.status) {
					this.programYearGet = true;
					this.scheduleYear = dotnetresponse.yearList;
					sessionStorage.setItem('filterProgrammeYear', JSON.stringify({ prog_year: this.scheduleYear }));
					if ('exhibition' != curparams.type) {
						let localSessionItems = JSON.parse(sessionStorage.getItem('filterProgrammeKeys'));
						if (localSessionItems.year != 0) {
							var result = this.scheduleYear.find(({ id }) => id === localSessionItems.year);
							if (null != result)
								this.selectedYear = result.code;
						} else
							this.selectedYear = this.scheduleYear[0].code;
					}
				}
			});
		}
	}

	showAllEvents() {
		this.filterButton = true;
		this.loadMoreButton = true;
		this.show_all_events_button = false;
		let localSessionItems = JSON.parse(sessionStorage.getItem('filterProgrammeKeys'));

		let params = {
			'offset': 0,
			'type': localSessionItems.type,
			'season': false,
		};
		localSessionItems.offset = params.offset;
		localSessionItems.season = params.season;
		localSessionItems.filter_type = '';
		localSessionItems.weekday_id = 0;
		localSessionItems.weekday_name = '';
		sessionStorage.setItem('filterProgrammeKeys', JSON.stringify(localSessionItems));
		this.currentDay = 'All days';
		this.week_day_id = 0;
		this.getFilterData(params, localSessionItems);
	}

	ngOnInit() {
		window.location.href = "https://trippus.net/worldwaterweek2024";
		return;
		/*setTimeout( () => {
			if ( (<HTMLInputElement>document.getElementById( 'show_hide_default_tags' ) ).value == 'showTags' ) {
				document.getElementById( 'topTags' ).click();
			}
		 }, 3000 );*/

		window.addEventListener("scroll", function () {
			let eventsDate = document.querySelectorAll('.events .events__date');
			Array.from(eventsDate).forEach(function (el, index) {
				if (el.clientHeight > (el.getBoundingClientRect().top + el.clientHeight)) {
					el.classList.add('sticky');
					if ( document.querySelector('#laterFixed') )
						document.querySelector('#laterFixed').innerHTML = el.innerHTML;
				} else
					el.classList.remove('sticky');
			})

			setTimeout(() => {
				let stickyCount = document.querySelectorAll('.sticky');
				if (stickyCount) {
					if (stickyCount.length > 0) {
						if ( document.querySelector('#time-zone') )
							document.querySelector('#time-zone').classList.add('sticky-header');
					} else {
						if ( document.querySelector('#time-zone') )
							document.querySelector('#time-zone').classList.remove('sticky-header');
					}
				}
			}, 100);
		});

		var headerClass = document.getElementsByClassName('header');
		if ( ! headerClass[0].classList.contains('inner_page_menu'))
			headerClass[0].classList.add('inner_page_menu');
	}

	ngAfterViewInit() {
		if ( ! document.querySelector('body').classList.contains('body-community-page'))
			document.querySelector('body').classList.add('body-community-page');

		if ( document.querySelector( '#time-zone' ) ) {
			let heightBeforeStikcy = document.querySelector( '#time-zone' ).clientHeight;
			document.getElementById( 'time-zone' ).style.minHeight = heightBeforeStikcy + 'px';
		}
	}

	changeView( event: any, id: string, classname: string ) {
		let localSessionItems = JSON.parse(sessionStorage.getItem('filterProgrammeKeys'));
		/* new */
		if (document.getElementById('schedule__events').classList.contains('schedule__events-extended-view'))
			document.getElementById('schedule__events').classList.remove('schedule__events-extended-view');
		if (document.getElementById('schedule__events').classList.contains('schedule__events-reduced-view'))
			document.getElementById('schedule__events').classList.remove('schedule__events-reduced-view');
		/* new */
		document.getElementById('schedule__events').classList.add('schedule__events-' + id + '-view');

		const hasClass = event.target.classList.contains(classname);
		if (hasClass) {
			event.target.classList.remove('schedule__view--activated');
			event.target.classList.add( classname );
		} else {
			var elems = document.querySelectorAll('.schedule__view--activated');
			[].forEach.call(elems, function (el) {
				el.classList.remove('schedule__view--activated');
			});
			event.target.classList.add( classname );
		}

		localSessionItems.view = id;
		sessionStorage.setItem('filterProgrammeKeys', JSON.stringify(localSessionItems));
		if ('extended' == localSessionItems.view || 'list' == localSessionItems.view) {
			document.getElementById('schedule').classList.remove('reduced');
			document.getElementById('schedule').classList.add('expanded');
		} else {
			document.getElementById('schedule').classList.remove('expanded');
			document.getElementById('schedule').classList.add('reduced');
		}
		this.ngAfterViewInit();
	}

	loadMoreScheduleList() {
		this.programTagsGet = false;
		this.programYearGet = false;
		this.loadMoreButton = true;
		this.showMoreButton = false;

		let localSessionItems = JSON.parse(sessionStorage.getItem('filterProgrammeKeys'));
		let next_offset = parseInt(localSessionItems.offset) + parseInt(localSessionItems.limit);
		let params = {
			'offset': localSessionItems.next_offset,
			'type': localSessionItems.type,
			'is_conference': localSessionItems.season,
		};
		/* update sessionStorage for offset */
		var methodName;
		if (!this.isMobile)
			methodName = this.accountService.getProgrammesByFilter(params);
		else
			methodName = this.accountService.getProgrammesByFilterMobile(params);
		methodName.then((dotnetresponse: any) => {
			if (dotnetresponse.status == 'Ok') {
				this.schedule_data = dotnetresponse.programmes;
				var groupByInterval = {};
				let c = this.schedule_data;
				this.schedule_data.forEach(function (a, b, c) {
					a.class = '';
					if (b > 0) {
						if (a.dateInterval != c[b - 1].dateInterval)
							a.class = 'blue-separator';
					} else if (b == 0) {
						if (a.dateInterval == c[b].dateInterval)
							a.class = 'blue-separator';
					}

					var leftConvenor = [];
					var rightConvenor = [];
					if (a.convenors.length > 0) {
						var convenor_count = a.convenors.length;
						var convenor_half_count = Math.round(convenor_count / 2);

						if (1 == convenor_count)
							leftConvenor = a.convenors;
						if (1 < convenor_count) {
							a.convenors.forEach(function (a, b) {
								if (b < convenor_half_count)
									leftConvenor.push(a);
								else
									rightConvenor.push(a);
							});
						}
					}
					if ( null != a.otherConvenor ) {
						if ( leftConvenor.length > rightConvenor.length ) {
							rightConvenor.push( {'name':a.otherConvenor} );
						} else {
							leftConvenor.push( {'name':a.otherConvenor} );
						}
					}

					groupByInterval[a.dateInterval] = groupByInterval[a.dateInterval] || [];
					groupByInterval[a.dateInterval].push({ val: a, lConvenor: leftConvenor, rConvenor: rightConvenor });
				});
				var object_length = Object.keys(groupByInterval).length;
				var increment = 0;
				var lstintval;
				var myArray1 = Object.keys(groupByInterval).map(function (key) {
					if (increment == object_length - 1)
						lstintval = key;
					var interval_arr = key.split('|');
					var day = interval_arr[0];
					var time = interval_arr[1];
					var seperator_class = groupByInterval[key][0].val.class;
					increment++;
					return { interval: key, values: groupByInterval[key], day: day, time: time, eventSeparatorClass: groupByInterval[key][0].val.class, eventdate:  groupByInterval[key][0].val.eventDate };
				});
				// let last:any = this.scheduleDotNetData[ this.scheduleDotNetData.length - 1 ];
				var last = (<HTMLInputElement>document.getElementById('hiddenlasttime')).value;
				let loop = 0;
				myArray1.forEach(( items, indexs ) => {
					this.curDays.forEach((item, index) => {
						if ( items.eventdate == item.date ) {
							myArray1[indexs]['focus_area'] = item.remarks;
						}
					});
				});
				for (let value of myArray1) {
					if (0 == loop && last == value.interval) {
						for (let val of value.values)
							this.scheduleDotNetData[this.scheduleDotNetData.length - 1].values.push(val);
					} else {
						loop = 1;
						this.scheduleDotNetData.push(value);
					}
				}
				this.lastInterval = lstintval;
				let count = this.schedule_data.length;
				if (count >= dotnetresponse.limit) {
					this.showMoreButton = true;
					this.filterCount = 1;
				} else {
					this.showMoreButton = false;
					this.filterCount = 0;
				}
				this.loadMoreButton = false;
			}

			localSessionItems.offset = next_offset;
			localSessionItems.next_offset = localSessionItems.offset + localSessionItems.limit;
			sessionStorage.setItem('filterProgrammeKeys', JSON.stringify(localSessionItems));

			if (localSessionItems.goldstandard == 1)
				setTimeout(function () {
					[].forEach.call(document.getElementsByClassName('gold-btn'), function (el) {
						el.classList.add('activated');
					});
				});
			if (localSessionItems.opensession == 1)
				setTimeout(function () {
					[].forEach.call(document.getElementsByClassName('btn-open-session'), function (el) {
						el.classList.add('activated');
					});
				});
		});
	}
	/* filter by tags, sessions, days, goldstandard */
	filterMore( event: any, filter_type, filter_id, filter_name ) {
		this.showTimezone = false;
		this.scheduleDotNetData = [];
		var option_type = '';
		this.filterButton = true;
		window.localStorage.setItem('filterClick', 'true');

		let selected_timezone = '';
		let localSessionItems = JSON.parse(sessionStorage.getItem('filterProgrammeKeys'));
		var tag_id;
		var tag_name;
		var filter_type_count;

		if ('timezone' != filter_type && event.target.classList.contains('activated'))
			this.removeFilter(event, filter_type, filter_id, filter_name);
		else {
			this.route.queryParams.subscribe(params => {
				if (params['tg'] || params['et'] || params['gs'] || params['os']) {
					var urlValue = document.location.href;
					urlValue = urlValue.split('?')[0];
					history.pushState({ state: 1, rand: Math.random() }, '', urlValue);
				}
			});
			if ('tags' == filter_type) {
				if (!this.isMobile)
					document.getElementById('closeTags').click();
				else
					setTimeout(() => {
						document.getElementById('closeTags').click();
					}, 1000);
				let tag_count = localSessionItems.tag_count;
				if ('goldstandard' != filter_name && 'opensession' != filter_name) {
					if (0 != filter_id) {
						this.showSelectedTagsText = true;
						this.showSelectedtags = true;
						this.tagsAll = false;

						filter_type_count = localSessionItems.filter_type_count + 1;
						tag_id = localSessionItems.filter_id;
						if (tag_id != '0') {
							localSessionItems.tag_count = localSessionItems.tag_count + 1;
							tag_id = tag_id + ',' + filter_id;
							tag_name = localSessionItems.tag_names + ',' + filter_name;
						} else {
							localSessionItems.tag_count = 1;
							tag_id = filter_id;
							tag_name = filter_name;
						}

						this.tag_list_name.push(filter_name);
						this.tag_list_id.push(filter_id);
					} else {
						this.tagsAll = true;
						filter_type_count = localSessionItems.filter_type_count - localSessionItems.tag_count;
						tag_id = filter_id;
						localSessionItems.tag_count = 0;
						if (0 != localSessionItems.goldstandard) {
							this.showSelectedTagsText = true;
							this.showSelectedtags = false;
							this.showSelectedgold = true;
							this.tag_list_id.forEach((itemid, index) => {
								if (itemid != 5000)
									this.tag_list_id.splice(index, 1);
							});
							this.tag_list_name.forEach((itemname, index) => {
								if (itemname != 'goldstandard')
									this.tag_list_name.splice(index, 1);
							});
						} else if (0 != localSessionItems.opensession) {
							this.showSelectedTagsText = true;
							this.showSelectedtags = false;
							this.showOpensession = true;

							this.tag_list_id.forEach((itemid, index) => {
								if (itemid != 25000)
									this.tag_list_id.splice(index, 1);
							});
							this.tag_list_name.forEach((itemname, index) => {
								if (itemname != 'opensession')
									this.tag_list_name.splice(index, 1);
							});
						} else {
							this.showSelectedTagsText = false;
							this.showSelectedtags = false;
							this.tag_list_id = [];
							this.tag_list_name = [];
						}
					}
				} else {
					this.showSelectedTagsText = true;
					if ('opensession' != filter_name) {
						this.showSelectedgold = true;
						var goldstandard = 1;
					} else {
						this.showOpensession = true;
						var opensession = 1;
					}
					this.tag_list_name.push(filter_name);
					this.tag_list_id.push(filter_id);
				}
			} else if ('year' == filter_type) {
				document.getElementById('closeYear').click();
				localSessionItems.year = filter_id;
				this.selectedYear = filter_name;
				if (undefined !== this.shareddata.scheduleSearchText && '' !== this.shareddata.scheduleSearchText) {
					localSessionItems.search_text = this.shareddata.scheduleSearchText;
					if ('' == localSessionItems.search_option) {
						option_type = 'All';
						localSessionItems.search_option = option_type;
						this.scheduleSearchOption = option_type;
					}
				}
			} else if ('text' == filter_type) {
				if (undefined !== this.shareddata.scheduleSearchText && '' !== this.shareddata.scheduleSearchText) {
					localSessionItems.search_text = this.shareddata.scheduleSearchText;
					option_type = 'All';
					localSessionItems.search_option = option_type;
					this.scheduleSearchOption = option_type;
				} else {
					localSessionItems.search_text = '';
					option_type = '';
					localSessionItems.search_option = option_type;
					this.scheduleSearchOption = option_type;
				}
			} else if ('search_option' == filter_type) {
				document.getElementById('closeSearchOption').click();
				option_type = filter_id;
				localSessionItems.search_option = option_type;
				this.scheduleSearchOption = option_type;
			} else if ('timezone' == filter_type)
				selected_timezone = event;
			else {
				if ('weekday' == filter_type) {
					document.getElementById('closeWeeks').click();
					if (0 != filter_id) {
						this.week_day_name = filter_name;
						this.week_day_id = filter_id;
						// this.currentDay = this.week_day_name.charAt(0).toUpperCase() + this.week_day_name.slice(1);
						this.curDays.forEach((item, index) => {
							if ( this.week_day_id == item.date ) {
								this.currentDay = item.date;
								this.focus_area = item.remarks;
							}
						});
					} else {
						this.week_day_name = '';
						this.week_day_id = 0;
						this.currentDay = 0;
					}
				} else {
					if (0 != filter_id) {
						this.showSelectedsession = true;
						this.sessionAll = false;
					} else {
						this.showSelectedsession = false;
						this.sessionAll = true;
					}

					document.getElementById('closeTags').click();
				}
				tag_id = filter_id;
			}

			let params = {
				'offset': 0,
				'type': localSessionItems.type,
				'search_text': this.shareddata.scheduleSearchText,
				'search_option': option_type,
				'filter_type': filter_type,
				'filter_id': filter_id,
				'filter_type_count': filter_type_count,
				'is_conference': localSessionItems.season,
			};
			/* update sessionStorage for search text */
			localSessionItems.offset = params.offset;
			localSessionItems.filter_type_count = filter_type_count;
			localSessionItems.filter_type = filter_type;
			localSessionItems.next_offset = 10;
			if ('' != selected_timezone)
				localSessionItems.timezone = this.selectedTimezone = selected_timezone;
			if ('tags' == filter_type) {
				if ('goldstandard' != filter_name && 'opensession' != filter_name) {
					localSessionItems.tag_id = filter_id;
					localSessionItems.filter_id = tag_id;
					localSessionItems.tag_names = tag_name;
				} else {
					if ('opensession' != filter_name)
						localSessionItems.goldstandard = goldstandard;
					else
						localSessionItems.opensession = opensession;
				}
			} else if ('session' == filter_type)
				localSessionItems.session_id = filter_id;
			else if ('weekday' == filter_type) {
				localSessionItems.weekday_id = filter_id;
				localSessionItems.weekday_name = filter_name;
			}
			if (localSessionItems.current_url.indexOf('?') >= 0) {
				var urlValue = document.location.href;
				localSessionItems.current_url = localSessionItems.current_url.split('?')[0];
			}
			sessionStorage.setItem('filterProgrammeKeys', JSON.stringify(localSessionItems));
			this.getFilterData(params, localSessionItems);
		}
	}
	/* remove filter by tags, sessions, days, goldstandard */
	removeFilter( event, filter_type, filter_id, filter_name ) {
		this.filterButton = true;
		this.route.queryParams.subscribe(params => {
			if (params['tg'] || params['et'] || params['gs'] || params['os']) {
				var urlValue = document.location.href;
				urlValue = urlValue.split('?')[0];
				history.pushState({ state: 1, rand: Math.random() }, '', urlValue);
			}
		});
		this.filterButton = true;
		event.target.classList.remove('activated');

		let localSessionItems = JSON.parse(sessionStorage.getItem('filterProgrammeKeys'));
		if (localSessionItems.current_url.indexOf('?') >= 0) {
			var urlValue = document.location.href;
			localSessionItems.current_url = localSessionItems.current_url.split('?')[0];
		}

		var filter_type_count = localSessionItems.filter_type_count;
		if ('session' != filter_type && 'goldstandard' != filter_type && 'opensession' != filter_type)
			filter_type_count = localSessionItems.filter_type_count - 1;

		if ('tags' == filter_type) {
			if (!this.isMobile)
				document.getElementById('closeTags').click();
			else
				setTimeout(() => {
					document.getElementById('closeTags').click();
				}, 1000);
			let tag_count = localSessionItems.tag_count;
			if ('goldstandard' != filter_name && 'opensession' != filter_name) {
				if (1 < tag_count) {
					this.showSelectedTagsText = true;
					this.showSelectedtags = true;
					this.tagsAll = false;
					var tag_array = localSessionItems.filter_id.split(',');
					tag_array.forEach((item, index) => {
						if (filter_id == item)
							tag_array.splice(index, 1);
					});
					tag_array.join(',');
					localSessionItems.filter_id = tag_array.toString();
					var tag_name_array = localSessionItems.tag_names.split(',');
					tag_name_array.forEach((item, index) => {
						if (filter_name == item)
							tag_name_array.splice(index, 1);
					});
					tag_name_array.join(',');
					localSessionItems.tag_names = tag_name_array.toString();
					this.tag_list_name.forEach((name, index) => {
						if (filter_name == name)
							this.tag_list_name.splice(index, 1);
					});
					this.tag_list_id.forEach((id, index) => {
						if (filter_id == id)
							this.tag_list_id.splice(index, 1);
					});
				} else {
					if (0 !== localSessionItems.goldstandard) {
						this.showSelectedTagsText = true;
						this.showSelectedtags = false;
						this.showSelectedgold = true;
						this.tagsAll = true;
						this.tag_list_name.forEach((name, index) => {
							if (filter_name == name)
								this.tag_list_name.splice(index, 1);
						});
						this.tag_list_id.forEach((id, index) => {
							if (filter_id == id)
								this.tag_list_id.splice(index, 1);
						});
					} else if (0 !== localSessionItems.opensession) {
						this.showSelectedTagsText = true;
						this.showSelectedtags = false;
						this.showOpensession = true;
						this.tagsAll = true;
						this.tag_list_name.forEach((name, index) => {
							if (filter_name == name)
								this.tag_list_name.splice(index, 1);
						});
						this.tag_list_id.forEach((id, index) => {
							if (filter_id == id)
								this.tag_list_id.splice(index, 1);
						});
					} else {
						this.showSelectedTagsText = false;
						this.showSelectedtags = false;
						this.tagsAll = true;
						this.tag_list_id = [];
						this.tag_list_name = [];
					}
					localSessionItems.tag_id = 0;
					localSessionItems.filter_id = 0;
				}
				localSessionItems.tag_count = tag_count - 1;
			} else {
				if ('opensession' != filter_name) {
					localSessionItems.goldstandard = 0;
					if (tag_count >= 1) {
						this.showSelectedTagsText = true;
						this.showSelectedgold = false;
						this.tagsAll = false;
						this.tag_list_name.forEach((name, index) => {
							if (filter_name == name)
								this.tag_list_name.splice(index, 1);
						});
						this.tag_list_id.forEach((id, index) => {
							if (filter_id == id)
								this.tag_list_id.splice(index, 1);
						});
					} else {
						this.showSelectedTagsText = false;
						this.showSelectedgold = false;
						this.tagsAll = true;
						this.tag_list_id = [];
						this.tag_list_name = [];
					}
				} else {
					localSessionItems.opensession = 0;
					if (tag_count >= 1) {
						this.showSelectedTagsText = true;
						this.showOpensession = false;
						this.tagsAll = false;
						this.tag_list_name.forEach((name, index) => {
							if (filter_name == name)
								this.tag_list_name.splice(index, 1);
						});
						this.tag_list_id.forEach((id, index) => {
							if (filter_id == id)
								this.tag_list_id.splice(index, 1);
						});
					} else {
						this.showSelectedTagsText = false;
						this.showOpensession = false;
						this.tagsAll = true;
						this.tag_list_id = [];
						this.tag_list_name = [];
					}
				}
			}
		} else {
			if ('weekday' == filter_type) {
				this.week_day_name = '';
				this.week_day_id = 0;
				localSessionItems.weekday_id = 0;
				localSessionItems.weekday_name = '';
			} else {
				document.getElementById('closeTags').click();
				this.showSelectedsession = false;
				this.sessionAll = true;
				localSessionItems.session_id = '0';
			}
		}
		localSessionItems.filter_type_count = filter_type_count;
		localSessionItems.offset = 0;
		window.sessionStorage.setItem('filterProgrammeKeys', JSON.stringify(localSessionItems));

		let params = {
			'offset': localSessionItems.offset,
			'type': localSessionItems.type,
			'search_option': localSessionItems.search_option,
			'search_text': localSessionItems.search_text,
			'is_conference': localSessionItems.season,
		};
		this.getFilterData(params, localSessionItems);
	}
	/* api calling */
	getFilterData( params, localSessionItems ) {
		this.programTagsGet = false;
		this.programYearGet = false;
		if (localSessionItems.season == true)
			this.show_all_events_button = true;
		let view = localSessionItems.view;
		this.offset_params = params.offset;
		this.selectedTimezone = localSessionItems.timezone;
		if (this.isMobile && localSessionItems.session_id == 0 && localSessionItems.goldstandard == 0 && localSessionItems.opensession == 0 && localSessionItems.tag_count == 0 && localSessionItems.search_text == '') {
			this.showSearchDiv = false;
			this.filterCount = 0;
			let parms = {
				'year': localSessionItems.year,
				'season': localSessionItems.season,
				'search_text': localSessionItems.search_text,
				'search_option': localSessionItems.search_option,
			}
			this.getYearTime(params);
		} else {
			if (!this.isMobile) {
				if ('' == this.curDays) {
					this.accountService.getCurrentDays(params).then((dotnetresponse: any) => {
						if ('Ok' === dotnetresponse.status) {
							// var daysArray = [];
							// dotnetresponse.DayList.forEach(function (a, b) {
							// 	daysArray.push(a.dayName);
							// });
							// this.curDays = daysArray;
							var daysArray = [];
							dotnetresponse.DayList.forEach( function( a, b ) {
								daysArray.push(a);
							});
							this.newDaysArr = daysArray;
							this.curDays = daysArray;
						}
					});
				}
			}
			this.showSearchDiv = false;
			var methodName;
			if (!this.isMobile)
				methodName = this.accountService.getProgrammesByFilter(params);
			else {
				let parms = {
					'year': localSessionItems.year,
					'season': localSessionItems.season,
					'search_text': localSessionItems.search_text,
					'search_option': localSessionItems.search_option,
				}
				this.getYearTime( params );
				methodName = this.accountService.getProgrammesByFilterMobile(params);
			}
			methodName.then((dotnetresponse: any) => {
				if (dotnetresponse.status == 'Ok') {
					this.currentDay =  localSessionItems.weekday_id;
					this.schedule_data = dotnetresponse.programmes;
					var groupByInterval = {};
					let c = this.schedule_data;
					this.schedule_data.forEach(function (a, b, c) {
						a.class = '';
						if (b > 0) {
							if (a.dateInterval != c[b - 1].dateInterval)
								a.class = 'blue-separator';
						} else if (b == 0) {
							if (a.dateInterval == c[b].dateInterval)
								a.class = 'blue-separator';
						}
						var leftConvenor = [];
						var rightConvenor = [];
						if (a.convenors.length > 0) {
							var convenor_count = a.convenors.length;
							var convenor_half_count = Math.round(convenor_count / 2);
							if (1 == convenor_count)
								leftConvenor = a.convenors;
							if (1 < convenor_count) {
								a.convenors.forEach(function (a, b) {
									if (b < convenor_half_count)
										leftConvenor.push(a);
									else
										rightConvenor.push(a);
								});
							}
						}
						if ( null != a.otherConvenor ) {
							if ( leftConvenor.length > rightConvenor.length ) {
								rightConvenor.push( {'name':a.otherConvenor} );
							} else {
								leftConvenor.push( {'name':a.otherConvenor} );
							}
						}

						groupByInterval[a.dateInterval] = groupByInterval[a.dateInterval] || [];
						groupByInterval[a.dateInterval].push({ val: a, lConvenor: leftConvenor, rConvenor: rightConvenor });
					});
					var myArray = Object.keys(groupByInterval).map(function (key) {
						var interval_arr = key.split('|');
						if ('exhibition' == params.type) {
							var day = 'Exhibitors';
							var time = 'All Week';
						} else {
							var day = interval_arr[0];
							var time = interval_arr[1];
						}

						return { interval: key, values: groupByInterval[key], day: day, time: time, eventSeparatorClass: groupByInterval[key][0].val.class, eventdate:  groupByInterval[key][0].val.eventDate };
					});
					myArray.forEach(( items, indexs ) => {
						this.curDays.forEach((item, index) => {
							if ( items.eventdate == item.date ) {
								myArray[indexs]['focus_area'] = item.remarks;
							}
						});
					});
					this.scheduleDotNetData = myArray;
				}
				this.filter_schedule_params = params;

				if (localSessionItems.year != 0) {
					var result = this.scheduleYear.find(({ id }) => id === localSessionItems.year);
					if (null != result)
						this.selectedYear = result.code;
				} else
					this.selectedYear = new Date().getFullYear();

				if (true == localSessionItems.season)
					this.filterCount = 1;
				else
					this.filterCount = localSessionItems.filter_type_count;
				sessionStorage.removeItem('filterProgrammeTags');
				sessionStorage.removeItem('filterProgrammeSessions');
				sessionStorage.removeItem('filterProgrammeYear');
				sessionStorage.setItem('filterProgrammeTags', JSON.stringify({ prog_tags: this.scheduleTags }));
				sessionStorage.setItem('filterProgrammeSessions', JSON.stringify({ prog_sessions: this.scheduleSessions }));
				sessionStorage.setItem('filterProgrammeYear', JSON.stringify({ prog_year: this.scheduleYear }));

				let count = this.schedule_data.length;
				if (count >= dotnetresponse.limit)
					this.showMoreButton = true;
				else
					this.showMoreButton = false;

				this.loadMoreButton = false;
				this.filterButton = false;
				this.showTimezone = true;

				var elems = document.querySelectorAll('.schedule__view--activated');
				if (elems.length > 0) {
					elems[0].classList.remove('schedule__view--activated');
					if (document.getElementById(view))
						document.getElementById(view).classList.add('schedule__view--activated');
				}

				document.getElementById('schedule__events').classList.remove('schedule__events', 'schedule__events-detail-view', 'schedule__events-thumbnail-view', 'schedule__events-extended-view', 'schedule__events-reduced-view');
				if ('extended' == localSessionItems.view || 'list' == localSessionItems.view)
					document.getElementById('schedule__events').classList.add('schedule__events', 'schedule__events-extended-view');
				else
					document.getElementById('schedule__events').classList.add('schedule__events', 'schedule__events-reduced-view');
				/* new */
				if (0 != localSessionItems.weekday_id)
					document.getElementById('allDays').classList.remove('activated');
				if (undefined != localSessionItems.search_text && '' != localSessionItems.search_text) {
					this.showSearchDiv = true;
					this.searchCount = dotnetresponse.searchResultCount;
					this.searchText = localSessionItems.search_text;
				} else {
					this.showSearchDiv = false;
					localSessionItems.search_option = 'All';
				}
				setTimeout(() => {
					if ('extended' == localSessionItems.view || 'list' == localSessionItems.view) {
						document.getElementById('schedule').classList.remove('reduced');
						document.getElementById('schedule').classList.add('expanded');
					} else {
						document.getElementById('schedule').classList.remove('expanded');
						document.getElementById('schedule').classList.add('reduced');
					}
				}, 1);
				this.defaultButton = false;
				/* new */
			});
			if ( 'timezone' == params.filter_type && !this.isMobile ) {
				this.accountService.getCurrentDays(params).then((dotnetresponse: any) => {
					if ('Ok' === dotnetresponse.status) {
						// var daysArray = [];
						// dotnetresponse.DayList.forEach(function (a, b) {
						// 	daysArray.push(a.dayName);
						// });
						// this.curDays = daysArray;
						var daysArray = [];
						dotnetresponse.DayList.forEach( function( a, b ) {
							daysArray.push(a);
						});
						this.newDaysArr = daysArray;
						this.curDays = daysArray;
					}
				});
			}
		}
	}

	/*saveFavourite( programmeId, favouriteId ) {
		if ( false === this.shareddata.loggedIn )
			return;

		let params: any;

		if ( 0 == favouriteId || 'null' == favouriteId || null == favouriteId )
			params = {
				"FavouriteType"   : 1,
				"FavouriteItemId" : programmeId,
				"favouriteId"  : favouriteId
			}
		else
			params = {
				"Id" : favouriteId,
				"favouriteId"  : favouriteId
			}
		this.funcs.globalsaveFavourite( programmeId, favouriteId, params, this.all_data, 'id' );
	}*/

	/*goToLoginPage() {
		document.getElementById( 'pageaccountclick' ).click();
	}*/

	highlight_search_text( content, type = null, position = null ) {
		return this.funcs.globalHighlightSearchText(content);
	}

	getDatabyDateTime( type, value, data = null, position = null ) {
		this.programTagsGet = false;
		this.programYearGet = false;
		if (true == position)
			this.isLastDate = true;
		else
			this.isLastDate = false;
		this.defaultButton = true;
		if ('date' == type || 'nextdate' == type) {
			var elems = document.querySelectorAll('.timediv');
			[].forEach.call(elems, function (el) {
				el.classList.remove('show');
				el.classList.add('hide');
			});
			var timeelems = document.querySelectorAll('.time-' + value);
			[].forEach.call(timeelems, function (ele) {
				ele.classList.remove('hide');
				ele.classList.add('show');
			});
			if (null !== data)
				this.activeDate = data;
			this.activeTime = timeelems[0].childNodes[1].textContent;
		} else
			this.activeTime = value;

		let params;
		if ('nextdate' == type || 'date' == type) {
			params = {
				'date': this.activeDate,
			}
			if ('nextdate' == type)
				this.all_data = this.schedule_data;
		} else {
			var elems1 = document.getElementsByClassName('current-date');
			if (null !== elems1[0].nextElementSibling) {
				var date = elems1[0].nextElementSibling.children[0].className;
				if (date.indexOf('last-date') > - 1)
					this.isLastDate = true;
				else
					this.isLastDate = false;
			} else
				this.isLastDate = true;
			params = {
				'date': this.activeDate,
				'time': this.activeTime,
			}
		}

		let localSessionItems = JSON.parse(sessionStorage.getItem('filterProgrammeKeys'));
		localSessionItems.date = this.activeDate;
		localSessionItems.offset = 0;
		localSessionItems.next_offset = 10;
		sessionStorage.setItem('filterProgrammeKeys', JSON.stringify(localSessionItems));

		this.accountService.getProgrammesByDateTime(params).then((dotnetresponse: any) => {
			if (dotnetresponse.status == 'Ok') {
				this.schedule_data = dotnetresponse.programmes;
				if ('nextdate' == type)
					this.all_data = this.all_data.concat(this.schedule_data);
				else
					this.all_data = this.schedule_data;
				var groupByInterval = {};
				let c = this.all_data;
				this.all_data.forEach(function (a, b, c) {
					a.class = '';
					if (b > 0) {
						if (a.dateInterval != c[b - 1].dateInterval)
							a.class = 'blue-separator';
					} else if (b == 0) {
						if (a.dateInterval == c[b].dateInterval)
							a.class = 'blue-separator';
					}

					var leftConvenor = [];
					var rightConvenor = [];
					if (a.convenors.length > 0) {
						var convenor_count = a.convenors.length;
						var convenor_half_count = Math.round(convenor_count / 2);

						if (1 == convenor_count)
							leftConvenor = a.convenors;
						if (1 < convenor_count) {
							a.convenors.forEach(function (a, b) {
								if (b < convenor_half_count)
									leftConvenor.push(a);
								else
									rightConvenor.push(a);
							});
						}
					}
					if ( null != a.otherConvenor ) {
						if ( leftConvenor.length > rightConvenor.length ) {
							rightConvenor.push( {'name':a.otherConvenor} );
						} else {
							leftConvenor.push( {'name':a.otherConvenor} );
						}
					}
					groupByInterval[a.dateInterval] = groupByInterval[a.dateInterval] || [];
					groupByInterval[a.dateInterval].push({ val: a, lConvenor: leftConvenor, rConvenor: rightConvenor });
				});

				var object_length = Object.keys(groupByInterval).length;
				var increment = 0;
				var lstintval;
				var myArray1 = Object.keys(groupByInterval).map(function (key) {
					if (increment == object_length - 1)
						lstintval = key;
					var interval_arr = key.split('|');
					var day = interval_arr[0];
					var time = interval_arr[1];
					var seperator_class = groupByInterval[key][0].val.class;
					increment++;
					return { interval: key, values: groupByInterval[key], day: day, time: time, eventSeparatorClass: groupByInterval[key][0].val.class, eventdate:  groupByInterval[key][0].val.eventDate };
				});
				myArray1.forEach(( items, indexs ) => {
					this.dateTimeArray.forEach((item, index) => {
						if( item.values[2].eventdate == items.eventdate ) {
							myArray1[indexs]['focus_area'] = item.values[1].remarks ;
						}
					});
				});
				this.scheduleDotNetData = myArray1;
				this.lastInterval = lstintval;
			}
			this.schedule_params = params;
			this.defaultButton = false;
			this.loadMoreButton = false;
			let count = this.schedule_data.length;
			// if (count >= dotnetresponse.limit) {
			// 	this.showMoreButton = true;
			// 	this.filterCount = 1;
			// } else
			// 	this.showMoreButton = false;
		});
	}

	loadNextDayScheduleList() {
		this.loadMoreButton = true;
		// this.filterCount = 1;
		var elems = document.getElementsByClassName('current-date');
		if (null !== elems[0].nextElementSibling) {
			var date = elems[0].nextElementSibling.children[0].className;
			if (date.indexOf('last-date') > - 1) {
				date = date.split(' ')[0];
				this.isLastDate = true;
				this.filterCount = 1;
			} else {
				this.isLastDate = false;
				this.filterCount = 0;
			}
			var id = elems[0].nextElementSibling.children[0].id;
			var id_arr = id.split('-').pop();
			let localSessionItems = JSON.parse(sessionStorage.getItem('filterProgrammeKeys'));
			localSessionItems.date = date
			localSessionItems.next_offset = 10;
			localSessionItems.offset = 0;
			sessionStorage.setItem('filterProgrammeKeys', JSON.stringify(localSessionItems));
			this.getDatabyDateTime('nextdate', id_arr, date);
			setTimeout(() => {
				const scrollElement = document.getElementById('dateDropdown');
				const yCoordinate = scrollElement.getBoundingClientRect().top + window.pageYOffset;
				let yOffset;

				yOffset = -60;
				window.scrollTo({
					top: yCoordinate + yOffset,
					behavior: 'smooth'
				});
			}, 1);
		}
	}

	addMenuId( object_id ) {
		sessionStorage.setItem('currentPageID', JSON.stringify(object_id));
	}

	enterSearch( $event, searchValue ) {
		this.shareddata.setScheduleSearchText(searchValue);
		if ($event.keyCode == 13 ) {
			document.getElementById( 'programmeSearchButton' ).click();
		}
	}
}